const useProjectStyles = () => {
    return {
        projectContentContainerStyles: {
            display: 'flex',
            flexDirection: 'column',
            gap: 3
        },
        projectsGridCardStyles: {
            p: 1.5
        },
        addProjectButtonStyles: {
            width: 36,
            height: 36,
            borderRadius: 500,
            minWidth: 'unset'
        }
    };
};
export default useProjectStyles;
